import { use } from 'react';

import { NETWORK_SCOPE } from '@/components/map/utils/resolveStatsScope';
import { StatsScopeContext, type StatsScopeContextValue } from './StatsScopeContext';

/**
 * Frozen fallback used when no <StatsScopeProvider> is present. This lets
 * MapView (which is also rendered standalone on the savi route and in tests,
 * with no provider) keep working unchanged: setScope becomes a no-op and the
 * scope is always the network, so context-aware stats are simply inert.
 */
const NOOP_VALUE: StatsScopeContextValue = Object.freeze({
    scope: NETWORK_SCOPE,
    setScope: () => {},
});

/**
 * Reads the stats-scope signal shared between MapView (which resolves the scope
 * from the map centre) and the Global Stats bar in the Find & Fix layout.
 * Returns a harmless no-op value when used outside a provider.
 */
export function useStatsScope(): StatsScopeContextValue {
    return use(StatsScopeContext) ?? NOOP_VALUE;
}
